module.exports = __webpack_public_path__ + "static/media/join-us-group-10.82c501cd.png";